import type { Employee, EmployeeRole, EmployeeLevel } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import { api } from './client';

/** Endpoints de empleados/técnicos (ADMIN). Prefijo: /api/employees */

export interface ListEmployeesParams {
  rol?: EmployeeRole;
  activo?: boolean;
  search?: string;
  skip?: number;
  take?: number;
}

export const listEmployees = (params: ListEmployeesParams = {}) =>
  api.get<Paginated<Employee>>('/api/employees', { query: params });

export const getEmployee = (id: string) => api.get<Employee>(`/api/employees/${id}`);

export const createEmployee = (input: {
  nombre: string;
  telefono?: string;
  rol: EmployeeRole;
  habilidades?: string[];
  nivel?: EmployeeLevel | null;
  userId?: string;
}) => api.post<Employee>('/api/employees', input);

export const updateEmployee = (
  id: string,
  data: {
    nombre?: string;
    telefono?: string | null;
    rol?: EmployeeRole;
    activo?: boolean;
    habilidades?: string[];
    nivel?: EmployeeLevel | null;
    userId?: string | null;
  },
) => api.patch<Employee>(`/api/employees/${id}`, data);

export const deactivateEmployee = (id: string) => api.del<Employee>(`/api/employees/${id}`);

/** Sube la foto del empleado (multipart). El navegador fija el Content-Type. */
export const uploadEmployeePhoto = (id: string, file: File) => {
  const form = new FormData();
  form.append('file', file);
  return api.post<Employee>(`/api/employees/${id}/photo`, form);
};
